import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AsyncPipe } from "@angular/common";
import { NewDialogComponent } from "common/newdialog/dialog.component";
import { DialogHeaderComponent } from "common/newdialog/dialog-header.component";
import { TranslateModule } from "@ngx-translate/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

type FileError = stages.file.FileError;

@Component({
	selector: "stages-files-error",
	templateUrl: "./files-error.component.html",
	styleUrls: ["./files-error.component.scss"],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [NewDialogComponent, DialogHeaderComponent, TranslateModule, ReactiveFormsModule, FormsModule, AsyncPipe],
})
export class FilesErrorComponent {
	private route = inject(ActivatedRoute);

	error$: Observable<FileError>;
	errorDetails$: Observable<unknown[]>;
	details = false;
	detailsState = "left";

	constructor() {
		this.error$ = this.route.data.pipe(map((data) => data.error));
		this.errorDetails$ = this.error$.pipe(
			map((error) => {
				const errorDetails: unknown[] = [];
				for (const prop in error.details) {
					if (error.details.hasOwnProperty(prop)) {
						errorDetails.push({ key: prop, value: error.details[prop] });
					}
				}
				return errorDetails;
			}),
		);
	}

	toggleState(): void {
		this.detailsState = this.detailsState === "left" ? "right" : "left";
	}
}
